class accordionFAQ extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			accordionItem: '.accordion-item',
		};

		this.elements = {
			accordionItem: document.querySelectorAll(this.selectors.accordionItem),
		};

		this.classes = {
			accordionItemActive: 'accordion-item--active',
		};

		this.init();
	}

	init() {
		this.elements.accordionItem.forEach((accordion) => {
			accordion.addEventListener('click', () => {
				accordion.classList.toggle(this.classes.accordionItemActive);
			});
		});
	}
}

customElements.define('accordion-faq', accordionFAQ);
